module.exports = __webpack_public_path__ + "img/next.2a47dedc.svg";